import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { RequestsService } from '../services/requests.service';
import * as XLSX from 'xlsx';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Router } from '@angular/router';


@Component({
  selector: 'app-packer-mover-request',
  templateUrl: './packer-mover-request.component.html',
  styleUrls: ['./packer-mover-request.component.sass']
})
export class PackerMoverRequestComponent implements OnInit {
  page: number = 1;
  itemsPerPage = 5;
  totalItems:any;
  allPackerMoverList:any;

  allPackerMoverList_forFilter:any;
  closeResult: string;
  viewAllData:any;
  constructor(private toastr:ToastrService,
    private spinner :NgxSpinnerService,
    private requestsService :RequestsService,
    private modalService: NgbModal,
    private router:Router) { }

  ngOnInit(): void {
    this.getQuoteEnterpriseRequests()
  }


  getQuoteEnterpriseRequests(){
    this.spinner.show();       
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    : 0,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      //  "isDeleted": 2        // 2 for getting all users
    }
    this.requestsService.getPackerMoverRequests(data).subscribe((result:any)=>{
      console.log('all data  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allPackerMoverList = result.data
        this.allPackerMoverList_forFilter = result.data
        this.totalItems = result.totalRecords;
      }else{
        this.allPackerMoverList = [];
        this.allPackerMoverList_forFilter = [];
      }
    })
  }

  gty(page: any){
    this.spinner.show();
    let data = { 
      "perPage" : this.itemsPerPage,
      "page"    :this.page-1,
      "isDeleted": 0     // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    }
    this.requestsService.getPackerMoverRequests(data).subscribe((result:any)=>{
      console.log('all data  ',result);
      this.spinner.hide()
      if(result.statusCode == 200){
        this.allPackerMoverList = result.data
        this.allPackerMoverList_forFilter = result.data
      }else{
        this.allPackerMoverList = [];
        this.allPackerMoverList_forFilter = [];
      }
    })
  }
  searchBy:string='';
  searchText:any;
  allPackerMoverPackagesList:any
  search(){
    if(this.searchText != ''){
        let data = {
          "fieldName" :  this.searchBy,
          "searchText" : this.searchText 
        } 
        this.spinner.show();
        this.requestsService.searchPackerMoverPackage(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.allPackerMoverList = result.data;
          }else{
            this.spinner.hide();
            this.toastr.error(result.message);
          }
          console.log(result)
        })
    }else{
      this.toastr.error('Please Fill Search text')
    }
  }


  applyFilter(filterValue:any){
    console.log(filterValue);
    let filterValueLower = filterValue.toLowerCase();
         if(filterValue === '' ) {
             this.allPackerMoverList=this.allPackerMoverList_forFilter;
         } 
         else {
           this.allPackerMoverList = this.allPackerMoverList_forFilter.filter((employee:any) => employee.packageName.toLowerCase().includes(filterValueLower) )
          }
  }

  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "Packers Movers Report.xlsx");
   }


   routeViewDetails(ID){
    this.router.navigate(['dashboard/viewPackerMoverRequest'], { queryParams : { id: ID } });
   }

}
